import './AuthForm.css';

const AuthForm = ({
  authState,
  email,
  password,
  confirmationCode,
  authError,
  onEmailChange,
  onPasswordChange,
  onConfirmationCodeChange,
  onSignIn,
  onSignUp,
  onConfirmSignUp,
  onSwitchAuthState
}) => {
  if (authState === 'signIn') {
    return (
      <div className="login-container">
        <form className="login-form" onSubmit={onSignIn}>
          <h2>Sign In</h2>
          {authError && <div className="auth-error">{authError}</div>}
          <div className="form-group">
            <label>Email:</label>
            <input
              type="email"
              value={email}
              onChange={(e) => onEmailChange(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label>Password:</label>
            <input
              type="password"
              value={password}
              onChange={(e) => onPasswordChange(e.target.value)}
              required
            />
          </div>
          <button type="submit" className="login-button">Sign In</button>
          <button
            type="button"
            className="switch-auth-button"
            onClick={() => onSwitchAuthState('signUp')}
          >
            Need an account? Sign Up
          </button>
        </form>
      </div>
    );
  }

  if (authState === 'signUp') {
    return (
      <div className="login-container">
        <form className="login-form" onSubmit={onSignUp}>
          <h2>Sign Up</h2>
          {authError && <div className="auth-error">{authError}</div>}
          <div className="form-group">
            <label>Email:</label>
            <input
              type="email"
              value={email}
              onChange={(e) => onEmailChange(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label>Password:</label>
            <input
              type="password"
              value={password}
              onChange={(e) => onPasswordChange(e.target.value)}
              required
            />
          </div>
          <button type="submit" className="login-button">Sign Up</button>
          <button
            type="button"
            className="switch-auth-button"
            onClick={() => onSwitchAuthState('signIn')}
          >
            Already have an account? Sign In
          </button>
        </form>
      </div>
    );
  }

  if (authState === 'confirmSignUp') {
    return (
      <div className="login-container">
        <form className="login-form" onSubmit={onConfirmSignUp}>
          <h2>Confirm Sign Up</h2>
          {authError && <div className="auth-error">{authError}</div>}
          <div className="form-group">
            <label>Confirmation Code:</label>
            <input
              type="text"
              value={confirmationCode}
              onChange={(e) => onConfirmationCodeChange(e.target.value)}
              required
            />
          </div>
          <button type="submit" className="login-button">Confirm</button>
        </form>
      </div>
    );
  }
};

export default AuthForm;
